import { useState } from 'react';
import PatternPulse from '../../PatternPulse';
import BreathingBreak from '../../BreathingBreak';
import WordOfDay from '../../WordOfDay';
import Flashcards from '../../Flashcards';

const TILES = [
  {
    id: 'word-of-day',
    title: 'Word of the Day',
    tag: 'Expand your vocabulary',
    accent: '📚',
    modal: 'wordOfDay',
  },
  {
    id: 'flashcards',
    title: 'Flashcards',
    tag: '15 science & math terms',
    accent: '🧠',
    modal: 'flashcards',
  },
  {
    id: 'wellness-break',
    title: 'Wellness Break',
    tag: 'Guided Breathing Session',
    accent: '🌿',
    modal: 'breathingBreak',
  },
  {
    id: 'pattern-pulse',
    title: 'Pattern Pulse',
    tag: 'Boost working memory',
    accent: '🧠',
    modal: 'patternPulse',
  },
];

export default function QuickTiles() {
  const [openModal, setOpenModal] = useState(null);

  return (
    <>
      <div className="quick-tiles">
        {TILES.map((tile) => (
          <article
            key={tile.id}
            className={`tile-card${tile.modal ? ' tile-card--interactive' : ''}`}
            onClick={tile.modal ? () => setOpenModal(tile.modal) : undefined}
            role={tile.modal ? 'button' : undefined}
            tabIndex={tile.modal ? 0 : undefined}
            onKeyDown={
              tile.modal
                ? (e) => {
                    if (e.key === 'Enter' || e.key === ' ') setOpenModal(tile.modal);
                  }
                : undefined
            }
          >
            <div className="tile-head">
              <span className="tile-accent" aria-hidden="true">
                {tile.accent}
              </span>
              <p className="tile-title">{tile.title}</p>
            </div>
            <p className="tile-tag">{tile.tag}</p>
          </article>
        ))}
      </div>

      {openModal === 'patternPulse' && (
        <PatternPulse onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'breathingBreak' && (
        <BreathingBreak onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'wordOfDay' && (
        <WordOfDay onClose={() => setOpenModal(null)} />
      )}
      {openModal === 'flashcards' && (
        <Flashcards onClose={() => setOpenModal(null)} />
      )}
    </>
  );
}
